/**
 * A helper function calculated the final estimated worth of all provided data inputs.
 *
 * @param tableData - The data to count with.
 */
export const getTotalWorthString = (
    netWorth: string | undefined | Number
): string => {
    const worth = Math.floor(Number(netWorth));

    return `$${worth.toLocaleString('en-US')}`;
};
